import { ILightRailItem } from '../../../types'
import {
  EpisodeListItemDetailsWrap,
  EpisodeListItemTitle,
  EpisodeListItemWrap,
} from './EpisodeListItemClip.style'
import { useProgramContext } from './ProgramContext'
import { ottRoot } from '../../Api'
import { EpisodeListItemThumbnailComp } from './EpisodeListItemThumbnailComp'
import { useMemo } from 'react'
import { asset_type_enum } from '../../types'
import Link from '../../../components/Link/Link'

export const EpisodeListItemClip = ({
  data,
  bigImage,
}: {
  data: ILightRailItem
  isLast: boolean
  bigImage?: boolean | undefined
}) => {
  const { episode, seasonNumber, program } = useProgramContext()

  const href = useMemo(() => {
    if (
      data.type === asset_type_enum.Trailer ||
      data.type == asset_type_enum.Movies
    ) {
      return `${ottRoot}/${data.id}`
    }
    if (episode !== data.id) {
      let seriesId = '0'
      if (typeof data.metas?.SeriesID === 'string') {
        seriesId = data.metas.SeriesID
      } else {
        seriesId = program.id + ''
      }
      return `${ottRoot}/series/${seriesId}/season/${
        data.metas?.SeasonNumber || seasonNumber
      }/${data.id}`
    }
    return ''
  }, [
    data.id,
    data.metas?.SeasonNumber,
    data.metas?.SeriesID,
    data.type,
    episode,
    program.id,
    seasonNumber,
  ])

  return (
    <EpisodeListItemWrap
      id={'ep' + data.id}
      data-episode-number={data.metas.EpisodeNumber}
    >
      <Link href={href}>
        <EpisodeListItemThumbnailComp
          isClip={true}
          name={data.name}
          images={data?.images}
          nowPlaying={episode === data.id}
          bigImage={bigImage}
        />
        <EpisodeListItemDetailsWrap itemProp={data.description}>
          <EpisodeListItemTitle>{data.name}</EpisodeListItemTitle>
        </EpisodeListItemDetailsWrap>
      </Link>
    </EpisodeListItemWrap>
  )
}
